import { combineReducers } from "redux";
import { CommentStatus, UserComment } from "../types";
import { getFailureActionType, getSuccessActionType } from "../utils";
import {
  ADD_FILTER_VALUES_FOR_COMMENTS,
  FETCH_COMMENTS_REQUEST,
  UPDATE_COMMENT_REQUEST,
  FETCH_COMMENT_STATUS_REQUEST,
} from "./constants";
import { Action, CommentsState, CommentsFilter } from "./types";

function items(
  state: CommentsState = { currentPage: 0, pageCount: 1, data: [] },
  action: Action
): CommentsState {
  switch (action.type) {
    case getSuccessActionType(FETCH_COMMENTS_REQUEST):
      return {
        ...action.payload,
        data:
          action.payload.currentPage === 1
            ? [...action.payload.data]
            : [...state.data, ...action.payload.data],
      };

    case UPDATE_COMMENT_REQUEST:
      return {
        ...state,
        data: state.data.map((comment) =>
          comment.id === action.data.commentId
            ? {
                ...comment,
                isFetching: true,
              }
            : comment
        ),
      };

    case getSuccessActionType(UPDATE_COMMENT_REQUEST):
      return {
        ...state,
        data: state.data.map((comment) =>
          comment.id === action.data.commentId
            ? {
                ...comment,
                status: action.payload.instance.status,
                isFetching: false,
              }
            : action.payload.updated_to_need_review_status.length > 0 &&
              action.payload.updated_to_need_review_status.find((item: UserComment) => comment.id === item.id)
            ? {
                ...comment,
                status: {
                  id: 45,
                  title: "COMMENT_NEEDS_REVIEW",
                  description: "New comments that need to be followed up and not reviewed",
                },
                isFetching: false,
              }
            : action.payload.updated_to_single_display_admin.length > 0 &&
              action.payload.updated_to_single_display_admin.find(
                (item: UserComment) => comment.id === item.id
              )
            ? {
                ...comment,
                status: {
                  id: 44,
                  title: "SINGLE_DISPLAY_ADMIN_COMMENT",
                  description: "عدم نمایش - کامنت دیگری از کاربر با وضعیت کاربر وجود دارد",
                },

                isFetching: false,
              }
            : comment
        ),
      };

    case getFailureActionType(UPDATE_COMMENT_REQUEST):
      return {
        ...state,
        data: state.data.map((comment) =>
          comment.id === action.data.commentId
            ? {
                ...comment,
                isFetching: false,
              }
            : comment
        ),
      };

    default:
      return state;
  }
}

function commentsFilterValues(state: CommentsFilter = {}, action: Action): CommentsFilter {
  switch (action.type) {
    case ADD_FILTER_VALUES_FOR_COMMENTS:
      return action.data;

    default:
      return state;
  }
}

function isFetching(state: boolean = false, action: Action): boolean {
  switch (action.type) {
    case FETCH_COMMENTS_REQUEST:
      return true;
    case getSuccessActionType(FETCH_COMMENTS_REQUEST):
    case getFailureActionType(FETCH_COMMENTS_REQUEST):
      return false;

    default:
      return state;
  }
}

function statusItems(state: CommentStatus[] = [], action: Action): CommentStatus[] {
  switch (action.type) {
    case getSuccessActionType(FETCH_COMMENT_STATUS_REQUEST):
      return action.payload;
    default:
      return state;
  }
}
export const comments = combineReducers({ items, isFetching, commentsFilterValues, statusItems });
